<div *ngIf="!singleMonth" class="calendar-month" fxLayout="column" fxLayoutAlign="start center">
    <span (click)="drillIn(calDate)" class="calendar-month--name forge-typography--heading1">
        {{calDate | date: 'MMMM'}}
    </span>
    <div class="calendar-day--names" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="calendar-day--name" *ngFor="let name of namesOfDays">{{name}}</div>
    </div>
    <div class="calendar-weeks" fxLayout="column" fxLayoutAlign="space-between center">
        <div class="calendar-week" *ngFor="let week of displayedWeeks" fxLayout="row" fxLayoutAlign="space-between center">
            <div *ngFor="let day of week" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="calendar-date" fxLayout="row" fxLayoutAlign="center center" (click)="onClick(day)"
                     [ngClass]="dateRangeClass(day)" [tabindex]="showDay(day) ? '0' : '-1'" [role]="showDay(day) ? 'button' : undefined" (keydown)="onKeyDown($event, day)">
                    <span class="calendar-number">{{showDay(day) ? (day | date: 'd') : ''}}</span>
                </div>
                <forge-tooltip *ngIf="showTooltip(day)" placement="bottom">{{tooltip(day)}}</forge-tooltip>
            </div>
        </div>
    </div>
</div>

<div *ngIf="singleMonth" class="calendar-month" fxLayout="column" fxLayoutAlign="start center" style="border-bottom: var(--forge-border-thin) solid var(--forge-theme-surface-container);">
    <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
        <div style="width: 100%;">
            <forge-button *ngIf="isDrillIn" (click)="drillIn()">
                <forge-icon name="arrow_back"></forge-icon>
                    Year view
                </forge-button>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" style="width: 100%;">
            <forge-icon-button dense (click)="changeMonth(-1)" [attr.aria-label]="changeMonthText(-1)">
                <forge-tooltip aria-hidden="true" placement="bottom">{{changeMonthText(-1)}}</forge-tooltip>
                <forge-icon name="keyboard_arrow_left"></forge-icon>
            </forge-icon-button>
            <div class="calendar-month--name forge-typography--heading2">{{startDate | date: 'MMMM yyyy'}}
            </div>
            <forge-icon-button dense (click)="changeMonth(1)" [attr.aria-label]="changeMonthText(1)">
                <forge-tooltip aria-hidden="true" placement="bottom">{{changeMonthText(1)}}</forge-tooltip>
                <forge-icon name="keyboard_arrow_right"></forge-icon>
            </forge-icon-button>
        </div>
        <div style="width: 100%;"></div>
    </div>
    <div class="calendar-month--days" fxLayout="row" fxLayoutAlign="space-between center" style="width:100%;">
        <div class="forge-typography--heading1" fxFlex="15" *ngFor="let name of namesOfDays">{{name}}</div>
    </div>

    <metadata-calendar-day [displayedWeeks]="displayedWeeks" [metadataModel]="metadataModel"
                           [formRepository]="formRepository" [propertyMetadata]="propertyMetadata" [parent]="parent"
                           [month]="startDate.getMonth()" [events]="currentMonthDates">
    </metadata-calendar-day>
</div>
